import React, { useEffect, useState } from "react";
import "./RecentListing.css";
import { Icon } from "@iconify/react";
import { useAccount, useWalletClient } from "wagmi";
import { checkBalanceToken, getListedNfts } from "../contractInteraction/contractInteraction";
import ListedCard from "../landListedCard/ListedCard";
import { getmapdata, firestoredb } from "../../firebase/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import Web3 from "web3";

function RecentListing(props) {
  const { address } = useAccount();
  const [balance, setBalance] = useState("");
  const [AllSquares, setAllSquares] = useState([]);
  const [mynfts, setMynfts] = useState([]);
  const [rentedNfts, setRentedNfts] = useState([]);

  const getListedPlots = async () => {
    setMynfts([])
    if (address) {
      // var mylist=[]
      await getListedNfts(address).then(res => {
        console.log("getListedNfts called");
        console.log(res);

        // res[0].map(async (item, index) => {
        //   await checkApproval(item.tokenId).then(res => setApprovalCheck(prev=>({...prev, [item.tokenId]: res})))

        // })

        // let rentedCoordinate = [];
        res.map(async (item, index) => {
          const mapnumber = item.coordinate.split("-");

          console.log(mapnumber[0]);
          let listingApproved;
          let landListed;
          let priceInUsdt = Web3.utils.fromWei(item.price, "ether");
          // console.log("Sequence Start", item.tokenId)
          // if (item.listed){
          //   console.log("Approval Check");
          //   listingApproved = await checkApproval(item.tokenId);
          //   landListed = false;
          //   console.log("Item Listed", item.listed)
          //   console.log("Approval Check End", listingApproved);
          // }
          // else{
          //   listingApproved = true;
          //   landListed = true;
          // }
          // console.log("Sequence End", item.tokenId)
          const docRef = doc(firestoredb, "map", mapnumber[0]);
          await getDoc(docRef).then(res => {
            // mylist.push(res.data()[item.coordinate])
            setMynfts(prev => [...prev, { data: res.data()[item.coordinate], coordinate: item.coordinate, tokenId: item.tokenId, mapNumber: mapnumber, landListed: item.listed, listPrice: priceInUsdt }])
            console.log("brooooooo", res.data()[item.coordinate]?.listRented)
          }).catch(err => {
            console.log(err);
          })
        })
      })

      // Getting rente NFTs

    }
  }


  const checkBalance = async () => {
    console.log(address);
    if (address) {
      console.log("ghus jaa ");
      await checkBalanceToken(address)
        .then((res) => {
          setBalance(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    checkBalance();
  }, [address]);

  useEffect(() => {
    console.log("In use", mynfts);
  }, [mynfts]);

  const getMapData1 = async () => {
    const mapdata = await getmapdata();
    setAllSquares(mapdata);
  };

  useEffect(() => {
    if (address) {
      getMapData1();
      getListedPlots();
    }

  }, [address]);


  return (
    <div>
      <div className="recent-listing">
        <div className="recent-listing-content">
          {/* <button className="d-flex align-items-center justify-content-center">
            {balance} USDT
          </button> */}

          <button className={`"d-flex align-items-center justify-content-center" ${props.hide}`}>
            <Icon
              icon="ion:chevron-back"
              color="white"
              width="30"
              height="25"
            />
            BACK
          </button>
          <div className="head-and-para">
            <div className="left">
              <h1>Recent Listings</h1>
              <p>(8)</p>
              <button>Sale</button>
              <button>Rent</button>
            </div>
            <div className="right">
              <button>See more..</button>
            </div>
          </div>
          <div className="card-wrapper">
            {/*
              AllSquares && AllSquares.length > 0 ?
                Object.keys(AllSquares[0].mapdata).map(function (key, index) {
                  if (index < 8) {
                    const value = AllSquares[0].mapdata[key];
                    value.discountedPrice = value.price - value.price * 0.8;
                    value.totalFee = value.discountedPrice * 0.1;
                    value.totalTax = value.discountedPrice * 0.05;
                    value.finalPrice = value.discountedPrice + value.totalFee + value.totalTax;
                    return <ListedCard value={value} item={key} />;
                  }
                }) : <></> */}
            {
              address ?
                mynfts.length > 0 &&

                mynfts.map((item, index) => {
                  const imageHtml = item.data.background.split("(");
                  return <ListedCard item={item} imageSrc={imageHtml[1]} />
                })
                :
                <ConnectButton />
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecentListing;
